import { styled, Typography } from '@mui/material';
import { theme } from '@theme/index';

export const Styles = {
  HeaderContainer: styled('header')(({ theme }) => ({
    // backgroundColor: 'grey',
    width: '1200px',
    height: '215px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    overflow: 'hidden',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      height: '150px',
      alignItems: 'center',
      margin: '0 auto',
      textAlign: 'center',
      justifyContent: 'center',
      width: '100%'
    }
  })),

  HeaderArea: styled('div')(({ theme }) => ({
    display: 'flex',
    maxWidth: '1200px',
    width: '170%',
    margin: '0 auto',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  })),

  LogoImage: styled('img')(({ theme }) => ({
    height: '250px',
    paddingTop: '30px',
    position: 'absolute',
    left: '10px',
    bottom: '0',
    marginBottom: '0px',
    zIndex: '1',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      height: '150px',
      left: '0',
      paddingTop: '0',
      margin: '0 auto'
    }
  })),

  LogoText: styled(Typography)({
    fontSize: '16px',
    width: '100%',
    height: '28px',
    textTransform: 'uppercase',
    background: '#2fb674',
    color: '#000000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
  }),

  BackgroundImage: styled('img')(({ theme }) => ({
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',

    // left: '9%',
    // marginBottom: '-10px',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  })),

  PhoneNumberOverlay: styled('div')<{ outline: boolean }>(
    ({ theme, outline }) => ({
      position: 'absolute',
      bottom: '30px',
      // left: '19%',
      right: '140px',
      display: 'flex',
      gap: '2px',
      alignItems: 'center',
      zIndex: '1',
      border: outline ? '2px dashed #04682E' : 'none',
      borderRadius: '4px',
      padding: '4px 8px',
      [theme.breakpoints.down('md')]: {
        display: 'none'
      }
    })
  ),

  PhoneNumberOverlayAnchorDot: styled('div')({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#04682E',
    position: 'absolute',
    bottom: '0',
    right: '0',
    transform: 'translate(50%, 50%)'
  }),

  PhoneNumberOverlayCoordinates: styled('div')({
    position: 'absolute',
    bottom: '0',
    right: '0',
    transform: 'translate(100%, 100%)',
    color: '#04682E',
    fontSize: '12px'
  }),

  PhoneNumberText: styled(Typography)({
    color: '#46342A',
    fontSize: '18px',
    fontWeight: 'bold',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    }
  })

  // GridBox: styled('div')(({ theme }) => ({
  //   position: 'static',
  //   margin: '0',
  //   padding: '5px',
  //   backgroundColor: '#b60a0a',
  //   borderRadius: '4px',
  //   border: '1px solid #ddd',
  //   fontSize: '14px',
  //   fontWeight: 'bold',
  //   width: '160px',
  //   height: '30px',
  //   alignSelf: 'center',
  //   transform: 'translateY(217px)' // ajuste numérico para descer mais
  // }))
};
